<template>
	<div class="viewport" ref="viewport" @keyup.esc="hideOverlay">
        <PageHeader />
        <Slider :slides=slidesData :startSlide=startSlide />
        <TableOfContents :cases=slidesData />
        <Overlay />
        <PageFooter />
	</div>
</template>

<script>
    const Slides = slides
    const Quiz = quiz
    import PageHeader from './components/PageHeader'
    import PageFooter from './components/PageFooter'
    import Overlay from './components/Overlay'
    import TableOfContents from './components/TableOfContents'
    import Slider from './views/Slider'
    
    export default {
        name: "App",
        components: { PageHeader, PageFooter, Slider, Overlay, TableOfContents },
        data: () => ({
            startSlide:0, loaded:false, slidesData:Slides, quizData:Quiz
        }),
        created(){
            let self = this

            window.addEventListener('keyup', e => {
                if(e.keyCode == 27 &&
                    (
                    self.$route.name === 'cases' ||
                    self.$route.name === 'about' ||
                    self.$route.name === 'poll'
                    )
                ) self.hideOverlay()
            })

            if(self.$route.params.slideId) self.startSlide = parseInt(self.$route.params.slideId)
            if(self.$route.params.caseId) self.showCase(self.$route.params.caseId)
            if(self.$route.name === 'about') self.showAbout()
            if(self.$route.name === 'poll') self.showPoll()
            
            self.$root.$on('hideOverlay', data => self.$router.push({ name:'index' }).catch(() => {}))
        },
        mounted(){},
        methods: {
            showOverlay(type, content){
                this.$root.$emit('showOverlay', { type, content })
            },
            hideOverlay(){
                this.$root.$emit('hideOverlay')
                this.scrollFix()
            },
            showCase(caseId){
                setTimeout(() => {
                    this.showOverlay('case', this.slidesData[caseId])
                })
            },
            showAbout(){
                setTimeout(() => {
                    this.showOverlay('about', '')
                })
            },
            showPoll(){
                setTimeout(() => {
                    this.showOverlay('poll', this.quizData)
                })
            },
            scrollFix(){
                window.scrollBy(0, -1)
            }
        },
        watch: {
            '$route'(to, from){
                if(to.name === 'cases') this.showCase(to.params.caseId)
                if(to.name === 'about') this.showAbout()
                if(to.name === 'poll') this.showPoll()
                if(
                    (to.name === 'index' || to.name === 'slides') &&
                    (from.name === 'cases' || from.name === 'poll' || from.name === 'about')
                ) this.hideOverlay()
            }
        }
    }
</script>

<style lang="scss">
    .viewport {
        width:100%; height:100vh; margin:0 auto 0; position:relative;
    }

    #page_header, #page_footer { position:fixed; width:100%; z-index:3; color:#fff; font-weight:bold; font-family:$sans-serif; text-transform:uppercase; font-size:fsz(.85rem) }
    #page_footer { bottom:0 }

    #page_footer {
        padding:$space/1.5 0 $space/2;
        a { color:#fff }
    }
</style>